// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"86":"6676e520","295":"f89fcab0","706":"66207de2","833":"d30a5b23","866":"e31f8c77"}[chunkId] + ".chunk.css";
};